import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Store from './store/root/store';

import { App } from './app/index';

export const StoreInstance = Store({});

ReactDOM.render(
  <Provider store={StoreInstance}>
    <App />
  </Provider>,
  document.querySelector('#registration-app')
);
